import React from 'react';
import styles from './ImageSkeleton.module.css';

export interface ImageSkeletonProps {
	id?: string;
	height?: string | number;
	width?: string | number;
	text?: string;
}

export const ImageSkeleton: React.FC<ImageSkeletonProps> = ({ id, text, ...style }: ImageSkeletonProps) => {
	return (
		<div className={styles.skeleton} style={style} id={id}>
			{text && text}
		</div>
	);
};
